var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcLock12 = function SvgIcLock12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 5C9.55228 5 10 5.44772 10 6V9C10 9.55228 9.55228 10 9 10H3C2.44772 10 2 9.55228 2 9V6C2 5.44772 2.44772 5 3 5V4C3 2.34315 4.34315 1 6 1C7.65685 1 9 2.34315 9 4V5ZM4.5 5H7.5V4C7.5 3.17157 6.82843 2.5 6 2.5C5.17157 2.5 4.5 3.17157 4.5 4V5Z",
    fill: "#525F7F"
  })));
};
export default SvgIcLock12;